import _defineProperty from "/var/www/costaatlanticamtbtour.com/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectSpread from "/var/www/costaatlanticamtbtour.com/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
import _toConsumableArray from "/var/www/costaatlanticamtbtour.com/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _objectWithoutProperties from "/var/www/costaatlanticamtbtour.com/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import { createContext as $3bkAK$createContext, useMemo as $3bkAK$useMemo, createElement as $3bkAK$createElement, useContext as $3bkAK$useContext } from "react";

function $c512c27ab02ef895$export$fd42f52fd3ae1109(rootComponentName, defaultContext) {
  var Context = /*#__PURE__*/$3bkAK$createContext(defaultContext);

  function Provider(props) {
    var children = props.children,
        context = _objectWithoutProperties(props, ["children"]); // Only re-memoize when prop values change
    // eslint-disable-next-line react-hooks/exhaustive-deps


    var value = $3bkAK$useMemo(function () {
      return context;
    }, Object.values(context));
    return /*#__PURE__*/$3bkAK$createElement(Context.Provider, {
      value: value
    }, children);
  }

  function useContext(consumerName) {
    var context = $3bkAK$useContext(Context);
    if (context) return context;
    if (defaultContext !== undefined) return defaultContext; // if a defaultContext wasn't specified, it's a required context.

    throw new Error("`".concat(consumerName, "` must be used within `").concat(rootComponentName, "`"));
  }

  Provider.displayName = rootComponentName + 'Provider';
  return [Provider, useContext];
}
/* -------------------------------------------------------------------------------------------------
 * createContextScope
 * -----------------------------------------------------------------------------------------------*/


function $c512c27ab02ef895$export$50c7b4e9d9f19c1(scopeName) {
  var createContextScopeDeps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var defaultContexts = [];
  /* -----------------------------------------------------------------------------------------------
  * createContext
  * ---------------------------------------------------------------------------------------------*/

  function $c512c27ab02ef895$export$fd42f52fd3ae1109(rootComponentName, defaultContext) {
    var BaseContext = /*#__PURE__*/$3bkAK$createContext(defaultContext);
    var index = defaultContexts.length;
    defaultContexts = [].concat(_toConsumableArray(defaultContexts), [defaultContext]);

    function Provider(props) {
      var scope = props.scope,
          children = props.children,
          context = _objectWithoutProperties(props, ["scope", "children"]);

      var Context = (scope === null || scope === void 0 ? void 0 : scope[scopeName][index]) || BaseContext; // Only re-memoize when prop values change
      // eslint-disable-next-line react-hooks/exhaustive-deps

      var value = $3bkAK$useMemo(function () {
        return context;
      }, Object.values(context));
      return /*#__PURE__*/$3bkAK$createElement(Context.Provider, {
        value: value
      }, children);
    }

    function useContext(consumerName, scope) {
      var Context = (scope === null || scope === void 0 ? void 0 : scope[scopeName][index]) || BaseContext;
      var context = $3bkAK$useContext(Context);
      if (context) return context;
      if (defaultContext !== undefined) return defaultContext; // if a defaultContext wasn't specified, it's a required context.

      throw new Error("`".concat(consumerName, "` must be used within `").concat(rootComponentName, "`"));
    }

    Provider.displayName = rootComponentName + 'Provider';
    return [Provider, useContext];
  }
  /* -----------------------------------------------------------------------------------------------
  * createScope
  * ---------------------------------------------------------------------------------------------*/


  var createScope = function createScope() {
    var scopeContexts = defaultContexts.map(function (defaultContext) {
      return /*#__PURE__*/$3bkAK$createContext(defaultContext);
    });
    return function useScope(scope) {
      var contexts = (scope === null || scope === void 0 ? void 0 : scope[scopeName]) || scopeContexts;
      return $3bkAK$useMemo(function () {
        return _defineProperty({}, "__scope".concat(scopeName), _objectSpread({}, scope, _defineProperty({}, scopeName, contexts)));
      }, [scope, contexts]);
    };
  };

  createScope.scopeName = scopeName;
  return [$c512c27ab02ef895$export$fd42f52fd3ae1109, $c512c27ab02ef895$var$composeContextScopes.apply(void 0, [createScope].concat(_toConsumableArray(createContextScopeDeps)))];
}
/* -------------------------------------------------------------------------------------------------
 * composeContextScopes
 * -----------------------------------------------------------------------------------------------*/


function $c512c27ab02ef895$var$composeContextScopes() {
  for (var _len = arguments.length, scopes = new Array(_len), _key = 0; _key < _len; _key++) {
    scopes[_key] = arguments[_key];
  }

  var baseScope = scopes[0];
  if (scopes.length === 1) return baseScope;

  var createScope1 = function createScope1() {
    var scopeHooks = scopes.map(function (createScope) {
      return {
        useScope: createScope(),
        scopeName: createScope.scopeName
      };
    });
    return function useComposedScopes(overrideScopes) {
      var nextScopes1 = scopeHooks.reduce(function (nextScopes, _ref2) {
        var useScope = _ref2.useScope,
            scopeName = _ref2.scopeName;
        // We are calling a hook inside a callback which React warns against to avoid inconsistent
        // renders, however, scoping doesn't have render side effects so we ignore the rule.
        // eslint-disable-next-line react-hooks/rules-of-hooks
        var scopeProps = useScope(overrideScopes);
        var currentScope = scopeProps["__scope".concat(scopeName)];
        return _objectSpread({}, nextScopes, currentScope);
      }, {});
      return $3bkAK$useMemo(function () {
        return _defineProperty({}, "__scope".concat(baseScope.scopeName), nextScopes1);
      }, [nextScopes1]);
    };
  };

  createScope1.scopeName = baseScope.scopeName;
  return createScope1;
}

export { $c512c27ab02ef895$export$fd42f52fd3ae1109 as createContext, $c512c27ab02ef895$export$50c7b4e9d9f19c1 as createContextScope };